import React from 'react'

function ProductDetailsButton() {
    return (
        <>
            <a href='#' id='ProdViewButton' type='button' className="btn btn-sm btn btn-bg product-view-button"> 
                View All Products
            </a>
        </>
    )
}

export default ProductDetailsButton;
